[
  {
    "code": "RO-AB",
    "name": "Alba"
  },
  {
    "code": "RO-AR",
    "name": "Arad"
  },
  {
    "code": "RO-AG",
    "name": "Arges"
  },
  {
    "code": "RO-BC",
    "name": "Bacau"
  },
  {
    "code": "RO-BH",
    "name": "Bihor"
  },
  {
    "code": "RO-BN",
    "name": "Bistrita-Nasaud"
  },
  {
    "code": "RO-BT",
    "name": "Botosani"
  },
  {
    "code": "RO-BR",
    "name": "Braila"
  },
  {
    "code": "RO-BV",
    "name": "Brasov"
  },
  {
    "code": "RO-B",
    "name": "Bucuresti"
  },
  {
    "code": "RO-BZ",
    "name": "Buzau"
  },
  {
    "code": "RO-CL",
    "name": "Calarasi"
  },
  {
    "code": "RO-CS",
    "name": "Caras-Severin"
  },
  {
    "code": "RO-CJ",
    "name": "Cluj"
  },
  {
    "code": "RO-CT",
    "name": "Constanta"
  },
  {
    "code": "RO-CV",
    "name": "Covasna"
  },
  {
    "code": "RO-DJ",
    "name": "Dolj"
  },
  {
    "code": "RO-DB",
    "name": "Dâmbovita"
  },
  {
    "code": "RO-GL",
    "name": "Galati"
  },
  {
    "code": "RO-GR",
    "name": "Giurgiu"
  },
  {
    "code": "RO-GJ",
    "name": "Gorj"
  },
  {
    "code": "RO-HR",
    "name": "Harghita"
  },
  {
    "code": "RO-HD",
    "name": "Hunedoara"
  },
  {
    "code": "RO-IL",
    "name": "Ialomita"
  },
  {
    "code": "RO-IS",
    "name": "Iasi"
  },
  {
    "code": "RO-IF",
    "name": "Ilfov"
  },
  {
    "code": "RO-MM",
    "name": "Maramures"
  },
  {
    "code": "RO-MH",
    "name": "Mehedinti"
  },
  {
    "code": "RO-MS",
    "name": "Mures"
  },
  {
    "code": "RO-NT",
    "name": "Neamt"
  },
  {
    "code": "RO-OT",
    "name": "Olt"
  },
  {
    "code": "RO-PH",
    "name": "Prahova"
  },
  {
    "code": "RO-SJ",
    "name": "Salaj"
  },
  {
    "code": "RO-SM",
    "name": "Satu Mare"
  },
  {
    "code": "RO-SB",
    "name": "Sibiu"
  },
  {
    "code": "RO-SV",
    "name": "Suceava"
  },
  {
    "code": "RO-TR",
    "name": "Teleorman"
  },
  {
    "code": "RO-TM",
    "name": "Timis"
  },
  {
    "code": "RO-TL",
    "name": "Tulcea"
  },
  {
    "code": "RO-VS",
    "name": "Vaslui"
  },
  {
    "code": "RO-VN",
    "name": "Vrancea"
  },
  {
    "code": "RO-VL",
    "name": "Vâlcea"
  }
]